import type { JSX, ReactNode } from 'react';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  /** Приписка под числом: единицы, доля, пояснение. */
  hint?: ReactNode;
  /**
   * Плитка тревожная: число окрашивается в цвет отказа.
   *
   * Только число, а не вся плитка: §12 отводит цвету роль статуса, и красная
   * подложка на четверти экрана делает красным весь обзор — то есть ровно
   * то, среди чего потом не найти настоящую аварию.
   */
  tone?: 'normal' | 'down' | 'warn';
}

/**
 * Число с подписью — плитка сводки.
 *
 * Отдельным модулем, а не внутри страницы: обзор состоит из них целиком,
 * и одинаковая высота с одинаковыми отступами здесь важнее, чем экономия
 * на файле.
 */
export function StatTile({ label, value, hint, tone = 'normal' }: StatTileProps): JSX.Element {
  const color = tone === 'down' ? 'text-down-fg' : tone === 'warn' ? 'text-warn' : 'text-fg';

  return (
    <div className="flex min-w-0 flex-col gap-0.5 rounded-sm border border-line-subtle bg-raised px-3 py-2">
      <div className="truncate font-mono text-2xs tracking-[0.06em] text-faint uppercase">
        {label}
      </div>
      <div className={`font-mono text-xl leading-tight font-semibold ${color}`}>{value}</div>
      {hint ? <div className="truncate text-xs text-dim">{hint}</div> : null}
    </div>
  );
}
